import React from 'react';
import { useIsDesktop } from '@shared/util/hooks';
import { BatchScheduleDesktop } from './BatchScheduleDesktop';
import { BatchScheduleMobile } from './BatchScheduleMobile';
import { BatchScheduleComponentProps } from './types';

export function BatchScheduleComponent(props: BatchScheduleComponentProps) {
  const isDesktop = useIsDesktop();

  if (isDesktop) {
    return <BatchScheduleDesktop {...props} />;
  } else {
    return <BatchScheduleMobile {...props} />;
  }
}
